import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setIabpAugmentationOptions } from '../store/options.actions'

export function* getIabpAugmentationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const iabpAugmentationOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getIabpAugmentationOptions,
    ])
    const { entity } = iabpAugmentationOptionsResponse
    if (entity) yield put(setIabpAugmentationOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getIabpAugmentationOptions() error: ${e}`))
  }
}

export function* getIabpAugmentationOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getIabpAugmentationOptions)
}
